var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTriangles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6641 33.043H31.0273C32.4219 33.043 33.0547 32.4102 33.0547 31.0156V12.6524C33.0547 11.6328 32.3984 11 31.4141 11C30.793 11 30.3477 11.2813 29.8906 11.7383L11.7383 29.8906C11.293 30.3477 11 30.7812 11 31.4141C11 32.3984 11.6328 33.043 12.6641 33.043Z",
    fill: "#006100",
    fillOpacity: 0.85
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3926 1.31387e-06H2.02934C0.634742 1.31387e-06 0.00194109 0.6328 0.00194109 2.0274V20.3907C0.00194109 21.4102 0.658241 22.043 1.64254 22.043C2.26364 22.043 2.70894 21.7617 3.16604 21.3047L21.3184 3.1524C21.7637 2.6953 22.0566 2.2618 22.0566 1.6289C22.0566 0.6446 21.4238 1.31387e-06 20.3926 1.31387e-06Z",
    fill: "#006100",
    fillOpacity: 0.85
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangles);
export default __webpack_public_path__ + "static/media/triangles.f5457ea2595cfe895d288a5d864a3c7e.svg";
export { ForwardRef as ReactComponent };